import { getAlarmProfiles } from "@src/cloud-connect/dependency-injection-container/get-alarm-profiles";
import { useEffect, useState } from "react";

export const useActiveAlarmProfileTitleAlarmListHook = () => {
  const [profileName, setProfileName] = useState<string>();

  const activeAlarmProfile = getAlarmProfiles().getActiveAlarmProfile();

  useEffect(() => {
    if (!activeAlarmProfile) return;

    const updateActiveAlarmProfileName = () => {
      setProfileName(activeAlarmProfile.getName());
    };

    updateActiveAlarmProfileName();
    activeAlarmProfile.addObserver(updateActiveAlarmProfileName);

    return () => {
      activeAlarmProfile.removeObserver(updateActiveAlarmProfileName);
    };
  }, [activeAlarmProfile]);
  return { profileName };
};
